<div class="training-hub">
  <div class="hub-topbar">
    <div>
      <h1>Support Center</h1>
      <div class="hub-sub">Training guides</div>
    </div>
    <input type="text" class="hub-search" [(ngModel)]="search" placeholder="Search…">
    <button class="back-btn" (click)="goBack()" title="Back to system">
      <img src="assets/icons/exit.svg" alt="Back to system">
    </button>
  </div>

  <div class="type-filters">
    <div class="type-chip" [class.active]="activeType === 'all'" (click)="activeType = 'all'">
      All ({{ countFor('all') }})
    </div>
    <div class="type-chip" *ngFor="let t of typeKeys" [class.active]="activeType === t" (click)="activeType = t">
      {{ typeLabels[t].icon }} {{ typeLabels[t].label }} ({{ countFor(t) }})
    </div>
  </div>

  <div class="hub-content">
    <p *ngIf="isLoading">Loading…</p>

    <div class="cards" *ngIf="!isLoading">
      <div class="card" *ngFor="let g of filteredGuides" (click)="openViewer(g)">
        <span class="card-type">{{ typeLabels[g.guideType].icon }} {{ typeLabels[g.guideType].label }}</span>
        <h4>{{ g.title }}</h4>
        <p>{{ g.shortDescription }}</p>
      </div>
    </div>

    <div class="empty-state" *ngIf="!isLoading && !filteredGuides.length">
      No guides to show yet.
    </div>
  </div>
</div>

<div class="viewer-overlay" *ngIf="viewerOpen" (click)="closeViewer()">
  <div class="viewer-modal" (click)="$event.stopPropagation()">
    <div class="viewer-head">
      <h3>{{ viewerGuide?.title }}</h3>
      <button class="close-x" (click)="closeViewer()">✕</button>
    </div>
    <div class="viewer-body">
      <div class="text-view" *ngIf="viewerKind === 'text'">{{ viewerGuide?.textContent }}</div>
      <iframe class="viewer-frame" *ngIf="viewerKind === 'iframe'" [src]="viewerEmbedUrl" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>
      <video class="viewer-frame" *ngIf="viewerKind === 'video'" [src]="viewerEmbedUrl" controls controlsList="nodownload" style="background:#000;"></video>
      <embed class="viewer-frame" *ngIf="viewerKind === 'embed'" [src]="viewerEmbedUrl" type="application/pdf">
      <div class="hint" *ngIf="viewerKind === 'none'">This guide has no viewable content.</div>
    </div>
    <div class="viewonly-note">Online viewing only.</div>
  </div>
</div>
